export default __webpack_public_path__ + "static/media/slidingmiddle.a77514b3.jpg";